module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "custom-classes-transition",
      "enter-active-class": ("animated " + (_vm.settingsObj.animation))
    }
  }, [_c('v-container', {
    staticStyle: {
      "min-height": "0"
    },
    attrs: {
      "fluid": "",
      "grid-list-lg": "",
      "mt-3": ""
    }
  }, [_c('contact-form', {
    attrs: {
      "isOpen": _vm.openForm
    },
    on: {
      "toggleForm": _vm.toggleForm
    }
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "offset-md3": ""
    }
  }, [_c('v-card', {
    class: [_vm.settingsObj.themeColor, 'lighten-1', 'white--text', 'elevation-8']
  }, [_c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Thank you for Visiting")])]), _vm._v(" "), _c('v-card-text', [_c('div', {
    staticClass: "contact--subheadline"
  }, [_vm._v("\n                        Want to get in touch? Just click below to send me a message. I'll get back to you as soon as possible.\n                    ")])]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": "",
      "dark": "",
      "ripple": ""
    },
    on: {
      "click": _vm.toggleForm
    }
  }, [_vm._v("Contact Me\n                    ")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18b7d132","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Contact.vue
// module id = 455
// module chunks = 0